import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Alert,
    Box
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Localized } from '@fluent/react';

interface IncompleteOfferDialogProps {
    open: boolean;
    onClose: () => void;
}

export const IncompleteOfferDialog: React.FC<IncompleteOfferDialogProps> = ({ open, onClose }) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Localized id="urs-offer-cannot-finish-process">Nie można zakończyć procesu</Localized>
            </DialogTitle>

            <DialogContent>
                <Alert severity="warning" icon={<WarningAmberIcon />}>
                    <Typography fontWeight={500}>
                        <Localized id="error-offer-all-notes-must-be-filled">_brak ocen</Localized>

                    </Typography>
                </Alert>

                <Box
                    mt={2}
                    sx={{
                        backgroundColor: '#f5f5f5',
                        borderRadius: 2,
                        px: 2,
                        py: 1.5,
                        display: 'flex',
                        alignItems: 'flex-start',
                    }}
                >
                    <InfoOutlinedIcon sx={{ mr: 1, color: 'info.main', mt: '2px' }} />
                    <Typography variant="body2">
                        <Localized id="urs-offer-cannot-finish-process-info">_info</Localized>
                    </Typography>
                </Box>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} variant="contained" color="primary" autoFocus size='small'>
                    <Localized id="close">close</Localized>
                </Button>
            </DialogActions>
        </Dialog>
    );
};
